module.exports = __webpack_public_path__ + "img/enter-li.07261814.svg";